import React from 'react';
import { TopbarContainer } from '..';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
} from '../../components';
import css from './FrequentyAskedQuestion.module.css';
function FrequentyAskedQuestion() {
  const [extraText, setExtraText] = React.useState(false);
  const [id, setId] = React.useState();
  const extraContent = (
    <span id="more-text">Lorem ipsum sit atem dolor Lorem ipsum sit atem dolor</span>
  );
  const showContent = id => {
    if (id === '1') {
      setId(id);
      setExtraText(!extraText);
    } else if (id === '2') {
      setId(id);
      setExtraText(!extraText);
    } else if (id === '3') {
      setId(id);
      setExtraText(!extraText);
    }
  };
  return (
    <div>
      <LayoutWrapperTopbar>
        <TopbarContainer />
      </LayoutWrapperTopbar>
      <LayoutSingleColumn>
        <LayoutWrapperMain>
          <div className={css.container}>
            <h1 className={css.heading}>Frequently Asked Questions</h1>

            <h2 className={css.subTitle}>How do i pay for the essentials or premium plan?</h2>
            <p className={css.section}>
              The way to pay for essential or premium packages is to use money because money is a
              legal purchasetool in this country and it is also the most sought-after item in the
              world, money is everything we all needmoney and we want money, we need money to make
              ends meet daily activities. {id === '1' && extraText && extraContent}
              <a onClick={() => showContent('1')}>
                {id === '1' && extraText ? ' Read Less' : ' Read More'}
              </a>
            </p>
            <h2 className={css.subTitle}>
              Can i cancel my essentials or premium plan subscription at anytime?
            </h2>
            <p className={css.section}>
              The way to pay for essential or premium packages is to use money because money is a
              legal purchasetool in this country and it is also the most sought-after item in the
              world, money is everything we all needmoney and we want money, we need money to make
              ends meet daily activities. {id === '2' && extraText && extraContent}
              <a onClick={() => showContent('2')}>
                {id === '2' && extraText ? ' Read Less' : ' Read More'}
              </a>
            </p>
            <h2 className={css.subTitle}>
              We need to add new users to our team. How will that be billed?
            </h2>
            <p className={css.section}>
              The way to pay for essential or premium packages is to use money because money is a
              legal purchasetool in this country and it is also the most sought-after item in the
              world, money is everything we all needmoney and we want money, we need money to make
              ends meet daily activities. {id === '3' && extraText && extraContent}
              <a onClick={() => showContent('3')}>
                {id === '3' && extraText ? ' Read Less' : ' Read More'}
              </a>
            </p>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </div>
  );
}

export default FrequentyAskedQuestion;
